import { Navigate, Link } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { LoginCard } from '../login/LoginCard'
import { Header } from './Header'
import { Footer } from './Footer'
import { CookieBanner } from './CookieBanner'
import { css } from './css'

const RECURSOS_RESUMO = [
  { titulo: 'Disponível a qualquer hora', icone: <><circle cx={12} cy={12} r={9} /><path d="M12 7v5l3 2" /></> },
  { titulo: 'No navegador ou no aplicativo', icone: <><rect x={5} y={2} width={14} height={20} rx={2} /><path d="M10 18h4" /></> },
  { titulo: 'Conexão automática com bancos', icone: <><path d="M20 11A8 8 0 0 0 6.3 6.3L3 9.6" /><path d="M4 13a8 8 0 0 0 13.7 4.7L21 14.4" /><path d="M3 5v4.6h4.6M21 19v-4.6h-4.6" /></> },
  { titulo: 'Compartilhamento com permissões', icone: <><circle cx={9} cy={8} r={3.2} /><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" /></> },
]

const OVERVIEW_ITENS = [
  { titulo: 'Meus lançamentos', texto: 'Todas as movimentações organizadas por conta e cartão, prontas para revisar.', icone: <><path d="M4 6h16M4 12h16M4 18h10" /></> },
  { titulo: 'Situação em tempo real', texto: 'Saiba quanto já entrou, quanto já saiu e o que ainda está pendente no mês.', icone: <><path d="M4 19V10M10 19V5M16 19v-7M22 19H2" /></> },
  { titulo: 'Conexão com bancos', texto: 'Contas conectadas via Open Finance se atualizam sozinhas, sem digitar nada.', icone: <><path d="M20 11A8 8 0 0 0 6.3 6.3L3 9.6" /><path d="M4 13a8 8 0 0 0 13.7 4.7L21 14.4" /><path d="M3 5v4.6h4.6M21 19v-4.6h-4.6" /></> },
]

const CARD = css('display: block; background: #131B2C; border: 1px solid rgba(255,255,255,0.08); border-radius: 14px; padding: 26px; text-decoration: none; transition: transform 0.15s, border-color 0.15s;')
const CARD_ICONE = css('width: 44px; height: 44px; border-radius: 10px; background: rgba(245,166,35,0.12); display: flex; align-items: center; justify-content: center; color: #F5A623; margin-bottom: 16px;')
const CARD_TITULO = css('color: #FFFFFF; font-size: 16px; font-weight: 700; margin-bottom: 8px;')
const CARD_TEXTO = css('color: #A8B0C3; font-size: 14px; line-height: 1.6;')

const FEATURES: { to: string; titulo: string; texto: string; icone: React.ReactNode }[] = [
  {
    to: '/precos', titulo: 'Contas e cartões', texto: 'Contas correntes, cartões de crédito, débito e pré-pagos com faturas calculadas automaticamente.',
    icone: <path d="M3 21h18M4 21V10M20 21V10M2 10l10-6 10 6M6 10v7M10 10v7M14 10v7M18 10v7" />,
  },
  {
    to: '/precos', titulo: 'Orçamento e metas', texto: 'Defina limites por categoria, receba alertas antes de estourar e acompanhe metas de longo prazo.',
    icone: <><path d="M12 12V3a9 9 0 1 1-9 9h9Z" /><path d="M12 3a9 9 0 0 1 9 9h-9V3Z" opacity={0.45} /></>,
  },
  {
    to: '/precos', titulo: 'Relatórios completos', texto: 'Compare meses, acompanhe categorias e projete seu saldo futuro com relatórios visuais.',
    icone: <path d="M4 19V10M10 19V5M16 19v-7M22 19H2" />,
  },
  {
    to: '/precos', titulo: 'Compartilhamento familiar', texto: 'Compartilhe suas contas com quem você confia, com permissões específicas para cada pessoa.',
    icone: <><circle cx={9} cy={8} r={3.2} /><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" /><circle cx={17.5} cy={9} r={2.6} /><path d="M15.7 14.6c2.6.3 4.3 2.2 4.3 5.4" /></>,
  },
  {
    to: '/conectar-bancos', titulo: 'Conexão automática com bancos', texto: 'Conecte suas contas via Open Finance e importe lançamentos automaticamente, com tecnologia da Pluggy.',
    icone: <><path d="M20 11A8 8 0 0 0 6.3 6.3L3 9.6" /><path d="M4 13a8 8 0 0 0 13.7 4.7L21 14.4" /><path d="M3 5v4.6h4.6M21 19v-4.6h-4.6" /></>,
  },
  {
    to: '/precos', titulo: 'Notificações em tempo real', texto: 'Saiba na hora quando uma conta conectada é atualizada, pelo site ou pelo aplicativo.',
    icone: <><path d="M6 10a6 6 0 1 1 12 0c0 4 1.5 5.5 1.5 5.5H4.5S6 14 6 10Z" /><path d="M9.5 18.5a2.5 2.5 0 0 0 5 0" /></>,
  },
]

export function HomePage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  if (isAuthenticated) return <Navigate to="/dashboard" replace />

  return (
    <div style={css('width: 100%; min-height: 100vh; background: #0B1220; display: flex; flex-direction: column;')}>
      <Header atual="home" />

      <div style={css('max-width: 1200px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 96px 32px 72px; display: flex; gap: 56px; align-items: center;')}>
        <div style={css('flex: 1; display: flex; flex-direction: column; gap: 24px;')}>
          <div style={css('display: inline-flex; align-items: center; gap: 8px; background: rgba(245,166,35,0.12); border: 1px solid rgba(245,166,35,0.3); border-radius: 999px; padding: 6px 14px; width: fit-content;')}>
            <span style={css('width: 6px; height: 6px; border-radius: 999px; background: #F5A623;')} />
            <span style={css('color: #F5A623; font-size: 12px; font-weight: 700;')}>Web e aplicativo, sempre sincronizados</span>
          </div>
          <h1 style={css('margin: 0; font-size: 48px; line-height: 1.15; font-weight: 800; color: #FFFFFF; letter-spacing: -0.5px;')}>Organize sua vida financeira em um só lugar</h1>
          <p style={css('margin: 0; font-size: 18px; line-height: 1.6; color: #A8B0C3; max-width: 480px;')}>Contas, cartões, orçamento, metas e relatórios — sozinho ou compartilhando com quem você confia. Conecte seus bancos automaticamente e pare de lançar tudo à mão.</p>
          <div style={css('display: flex; flex-wrap: wrap; gap: 16px 24px;')}>
            {RECURSOS_RESUMO.map((r) => (
              <div key={r.titulo} style={css('display: flex; align-items: center; gap: 8px;')}>
                <svg viewBox="0 0 24 24" width={16} height={16} fill="none" stroke="#F5A623" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>{r.icone}</svg>
                <span style={css('color: #DCE1EC; font-size: 13px;')}>{r.titulo}</span>
              </div>
            ))}
          </div>
          <div style={css('margin-top: 8px;')}>
            <Link to="/criar-conta" style={css('display: inline-block; background: #F5A623; color: #0B1220; font-weight: 700; font-size: 15px; padding: 14px 28px; border-radius: 10px; text-decoration: none;')}>Criar minha conta grátis</Link>
          </div>
        </div>
        <div style={css('flex: 1; display: flex; justify-content: center;')}>
          <LoginCard />
        </div>
      </div>

      <div style={css('max-width: 1100px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 0 32px 96px; display: flex; flex-direction: column; gap: 40px; align-items: center;')}>
        <div style={css('text-align: center; display: flex; flex-direction: column; gap: 12px; max-width: 620px;')}>
          <span style={css('color: #F5A623; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px;')}>Depois de entrar</span>
          <h2 style={css('margin: 0; color: #FFFFFF; font-size: 30px; font-weight: 800;')}>Veja o que te espera lá dentro</h2>
          <p style={css('margin: 0; color: #A8B0C3; font-size: 15px;')}>Um painel simples com tudo que importa pra sua vida financeira, atualizado sozinho.</p>
        </div>

        <div style={css('display: flex; gap: 40px; align-items: center; flex-wrap: wrap; justify-content: center;')}>
          <div style={css('flex: 1; min-width: 280px; max-width: 380px; display: flex; flex-direction: column; gap: 20px;')}>
            {OVERVIEW_ITENS.map((it) => (
              <div key={it.titulo} style={css('display: flex; gap: 14px; align-items: flex-start;')}>
                <div style={css('width: 36px; height: 36px; border-radius: 9px; background: rgba(245,166,35,0.12); display: flex; align-items: center; justify-content: center; color: #F5A623; flex-shrink: 0;')}>
                  <svg viewBox="0 0 24 24" width={17} height={17} fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">{it.icone}</svg>
                </div>
                <div>
                  <div style={css('color: #FFFFFF; font-size: 15px; font-weight: 700; margin-bottom: 4px;')}>{it.titulo}</div>
                  <div style={css('color: #A8B0C3; font-size: 13.5px; line-height: 1.6;')}>{it.texto}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={css('width: 380px; background: #131B2C; border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 24px; box-shadow: 0 24px 60px rgba(0,0,0,0.4);')}>
            <div style={css('display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;')}>
              <span style={css('color: #6B7691; font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;')}>Patrimônio total</span>
              <span style={css('color: #3AC17E; font-size: 12px; font-weight: 700;')}>↑ 4,2%</span>
            </div>
            <div style={css('color: #FFFFFF; font-size: 30px; font-weight: 800; margin-bottom: 22px;')}>R$ 42.850,00</div>
            <div style={css('display: flex; gap: 12px; margin-bottom: 20px;')}>
              <div style={css('flex: 1; background: rgba(58,193,126,0.1); border-radius: 10px; padding: 14px;')}>
                <div style={css('color: #6B7691; font-size: 11px; margin-bottom: 6px;')}>Receitas do mês</div>
                <div style={css('color: #3AC17E; font-size: 17px; font-weight: 700;')}>R$ 8.200</div>
              </div>
              <div style={css('flex: 1; background: rgba(240,90,90,0.1); border-radius: 10px; padding: 14px;')}>
                <div style={css('color: #6B7691; font-size: 11px; margin-bottom: 6px;')}>Gastos do mês</div>
                <div style={css('color: #E96A6A; font-size: 17px; font-weight: 700;')}>R$ 5.430</div>
              </div>
            </div>
            <div style={css('display: flex; flex-direction: column; gap: 10px;')}>
              <div style={css('display: flex; align-items: center; gap: 10px; padding: 10px; background: rgba(255,255,255,0.03); border-radius: 8px;')}>
                <div style={css('width: 28px; height: 28px; border-radius: 999px; background: rgba(245,166,35,0.15); display: flex; align-items: center; justify-content: center; color: #F5A623; flex-shrink: 0;')}>
                  <svg viewBox="0 0 24 24" width={14} height={14} fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M20 11A8 8 0 0 0 6.3 6.3L3 9.6M4 13a8 8 0 0 0 13.7 4.7L21 14.4" /><path d="M3 5v4.6h4.6M21 19v-4.6h-4.6" /></svg>
                </div>
                <span style={css('color: #DCE1EC; font-size: 13px; flex-grow: 1;')}>Nubank atualizado automaticamente</span>
              </div>
              <div style={css('display: flex; align-items: center; gap: 10px; padding: 10px; background: rgba(255,255,255,0.03); border-radius: 8px;')}>
                <div style={css('width: 28px; height: 28px; border-radius: 999px; background: rgba(58,193,126,0.15); display: flex; align-items: center; justify-content: center; color: #3AC17E; flex-shrink: 0;')}>
                  <svg viewBox="0 0 24 24" width={14} height={14} fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"><circle cx={12} cy={12} r={8.5} /><circle cx={12} cy={12} r={4.5} /><circle cx={12} cy={12} r={1} /></svg>
                </div>
                <span style={css('color: #DCE1EC; font-size: 13px; flex-grow: 1;')}>Meta "Viagem" 68% concluída</span>
              </div>
            </div>
            <div style={css('margin-top: 16px; font-size: 11px; color: #4E5872; text-align: center;')}>Ilustração da interface — não é uma captura de tela real</div>
          </div>
        </div>
      </div>

      <div id="produto" style={css('max-width: 1200px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 40px 32px 96px; display: flex; flex-direction: column; gap: 48px;')}>
        <div style={css('text-align: center; display: flex; flex-direction: column; gap: 12px; max-width: 620px; margin: 0 auto;')}>
          <span style={css('color: #F5A623; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px;')}>Tudo em um só lugar</span>
          <h2 style={css('margin: 0; color: #FFFFFF; font-size: 32px; font-weight: 800;')}>Feito para quem quer entender pra onde vai o dinheiro</h2>
        </div>
        <div style={css('display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px;')}>
          {FEATURES.map((f) => (
            <Link key={f.titulo} to={f.to} style={CARD}>
              <div style={CARD_ICONE}>
                <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">{f.icone}</svg>
              </div>
              <div style={CARD_TITULO}>{f.titulo}</div>
              <div style={CARD_TEXTO}>{f.texto}</div>
            </Link>
          ))}
        </div>
      </div>

      <div style={css('max-width: 1200px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 0 32px 96px;')}>
        <div style={css('background: linear-gradient(135deg, #17233A, #0F1729); border: 1px solid rgba(245,166,35,0.2); border-radius: 20px; padding: 56px; display: flex; justify-content: space-between; align-items: center; gap: 32px; flex-wrap: wrap;')}>
          <div style={css('display: flex; flex-direction: column; gap: 10px; max-width: 460px;')}>
            <h2 style={css('margin: 0; color: #FFFFFF; font-size: 26px; font-weight: 800;')}>Comece agora, é grátis</h2>
            <p style={css('margin: 0; color: #A8B0C3; font-size: 15px; line-height: 1.6;')}>Crie sua conta em minutos e leve o Walleon pra onde você for, no navegador ou no aplicativo.</p>
          </div>
          <Link to="/criar-conta" style={css('background: #F5A623; color: #0B1220; font-weight: 700; font-size: 15px; padding: 14px 30px; border-radius: 10px; white-space: nowrap; text-decoration: none;')}>Criar conta grátis</Link>
        </div>
      </div>

      <Footer />
      <CookieBanner />
    </div>
  )
}
